// These French strings are the canonical stored values in the database.
// They are rendered as-is regardless of locale — no i18n translation applied.
// Custom free-text entry is allowed via the ComboboxInput component.
export const OPERATION_OPTIONS: readonly string[] = [
  'Surfacage',
  'Epaulement',
  'Rainurage',
  'Pochage',
  'Interpolation hélicoïdale',
  'Centrage',
  'Perçage sur face plate',
  'Alésage',
];
